import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";
import { useSelection } from "@frend-digital/centra/client";
import { formatCartItems } from "@frend-digital/centra/formatting";

const itemCount = (data: BaseSelectionResponse) =>
	data.selection?.items?.reduce((acc, value) => acc + (value.quantity ?? 0), 0);

export type CartItem = NonNullable<ReturnType<typeof formatCartItems>>[number];

export const useCart = () => {
	return useSelection({
		select: (data) => {
			const itemDiscount =
				data?.selection?.items?.reduce((acc, item) => {
					const before = item.totalPriceBeforeDiscountAsNumber || 0;
					const after = item.totalPriceAfterDiscountAsNumber || 0;
					return acc + (before - after);
				}, 0) ?? 0;

			const totalBeforeDiscount = data?.selection?.items?.reduce((sum, item) => {
				const itemTotal = item.totalPriceBeforeDiscountAsNumber || 0;
				return sum + itemTotal;
			}, 0);

			return {
				items: formatCartItems(data),
				total: data.selection?.totals?.grandTotalPrice,
				totalAsNumber: data.selection?.totals.grandTotalPriceAsNumber,
				count: itemCount(data),
				shippingPrice: data.selection?.totals?.shippingPrice,
				shippingPriceAsNumber: data?.selection?.totals?.shippingPriceAsNumber,
				totalProductPrice: data.selection?.totals?.itemsTotalPrice,
				vouchers: data?.selection?.discounts?.vouchers,
				currency: data?.selection?.currency,
				totals: data.selection?.totals,
				itemDiscount: itemDiscount,
				totalBeforeDiscount: totalBeforeDiscount,
				automaticDiscounts: data?.selection?.discounts?.automaticDiscounts,
			};
		},
	});
};

export const useCartItemCount = () => {
	return useSelection({
		select: (data) => {
			return itemCount(data);
		},
	});
};
